(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/pullAllBy', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/pullAllBy'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.pullAllBy, global.convert);
    global.pullAllBy = mod.exports;
  }
})(this, function (exports, _pullAllBy2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.pullAllBy = undefined;

  var _pullAllBy3 = _interopRequireDefault(_pullAllBy2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.pullAll} except that it accepts <code>iteratee</code> to generate the criterion by which each element is compared.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {Array} values The values to remove.
   * @param {Function} [iteratee={@link https://lodash.com/docs#identity|lodash.identity}] The iteratee invoked per element.
   * @return {Object} Returns the updated object.
   * @example pullAllBy({ nested: { prop: [{ x: 1 }, { x: 2 }, { x: 3 }, { x: 1 }, { x: 2 }, { x: 3 }] } }, 'nested.prop', [{ x: 1 }, { x: 3 }], 'x') // => { nested: { prop: [{ x: 2 }, { x: 2 }] } }
   * @see {@link https://lodash.com/docs#pullAllBy|lodash.pullAllBy} for more information.
   * @since 0.3.0
   */
  var pullAllBy = (0, _convert.convert)(_pullAllBy3.default);
  exports.pullAllBy = pullAllBy;
  exports.default = pullAllBy;
});